var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_1",
    "data-name": "Component 2 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.66,
    height: 30.064,
    viewBox: "0 0 44.66 30.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(3.552 1.386) rotate(-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    transform: "translate(11.831 0.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M2.835.016A4.007,4.007,0,0,1,6.281,3.461L8.714,27.8a2.474,2.474,0,0,1-2.819,2.819,4.007,4.007,0,0,1-3.445-3.445L.016,2.835A2.474,2.474,0,0,1,2.835.016Z",
    transform: "translate(21.665 0) rotate(45)",
    fill: "#EC892A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M5.895.016A2.474,2.474,0,0,1,8.714,2.835L6.281,27.177a4.007,4.007,0,0,1-3.445,3.445A2.474,2.474,0,0,1,.016,27.8L2.449,3.461A4.007,4.007,0,0,1,5.895.016Z",
    transform: "translate(-3.594 6.864) rotate(-45)",
    fill: "#EC892A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b29877e6ccf874c4bac9aaca95cabfa4.svg";
export { ForwardRef as ReactComponent };